import { mergeMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import * as Actions from './fill-providers.actions';
import * as FillProvidersApi from './fill-providers.api';

export const getFillProviders = (action$) =>
  action$.pipe(
    ofType(Actions.GET_FILL_PROVIDERS_REQUEST),
    mergeMap(() =>
      FillProvidersApi.getFillProviders().pipe(
        map(({ shipping }) => Actions.getFillProvidersSuccess(shipping)),
        catchError((error) => of(Actions.getFillProvidersFailure(error))),
      ),
    ),
  );
